export interface NavLink {
  icon: string;
  label: string;
  route: string;
  path_route: number;
}

const permissionIndex: NavLink[] = [
  {
    icon: 'home',
    label: 'Início',
    route: '/main/home',
    path_route: 0,
  },
  {
    icon: 'today',
    label: 'Período Letivo',
    route: '/main/plano-letivo',
    path_route: 1,
  },
  {
    icon: 'campaign',
    label: 'Avisos',
    route: '/main/notifications',
    path_route: 2,
  },
  {
    icon: 'home_work',
    label: 'Escolas',
    route: '/main/schools',
    path_route: 3,
  },
  {
    icon: 'event_note',
    label: 'Rotinas Pedagógicas',
    route: '/main/rotinas-pedagogicas',
    path_route: 4,
  },
  {
    icon: 'library_books',
    label: 'Banco de Habilidades',
    route: '/main/banco-de-habilidades',
    path_route: 5,
  },
  {
    icon: 'insights',
    label: 'Inteligência de Dados',
    route: '/main/inteligencia-de-dados',
    path_route: 6,
  },
  {
    icon: 'fact_check',
    label: 'Gestão Pedagógica Investigada',
    route: '/main/gestao-pedagogica-investigada',
    path_route: 7,
  },
];

export default permissionIndex;
